<div class="action-column flex flex-row items-center justify-center gap-[2px] cursor-pointer xs:justify-start">
  <rfc-icon *ngFor="let action of actions" [iconInput]="action.icon" (click)="navigate(action.path)"
    class="hover:opacity-80 transition-opacity"></rfc-icon>
</div>